import { render, staticRenderFns } from "./WDImageAvatarPreview.vue?vue&type=template&id=22bebc70&"
import script from "./WDImageAvatarPreview.vue?vue&type=script&lang=js&"
export * from "./WDImageAvatarPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports